import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import {
  dateToTimestamp,
  timestampToDate,
  unNullifyArrays,
} from '../../utils/fieldNormalizers';

/** @typedef { import('./_types').Trainer } Trainer */
const arrayKeys = [
  'tags',
  'reportsRole',
  'disabledTabs',
  'disabledDashboardBoxes',
  'disabledDashboardNotifications',
  'disabledEmails',
  'headTrainerEmails',
];

/** @type {(user: any) => Trainer} */
export function normalizeTrainer(trainer) {
  let camelized = camelcaseKeys(trainer);
  if (!camelized) return camelized;

  return {
    ...unNullifyArrays(camelized, arrayKeys),
    createdAt: timestampToDate(camelized.createdAt),
    updatedAt: timestampToDate(camelized.updatedAt),
    endedAt: timestampToDate(camelized.endedAt),
  };
}

/** @type {(user: Partial<Trainer>) => any} */
export function denormalizeTrainer(trainer) {
  const obj = decamelizeKeys(trainer, { deep: true });

  return {
    ...obj,
    created_at: dateToTimestamp(trainer.createdAt),
    updated_at: dateToTimestamp(trainer.updatedAt),
    ended_at: dateToTimestamp(trainer.endedAt),
  };
}
